import { useQuery } from "@tanstack/react-query";
import { getUsers } from "../api/auth";

export const useUsers = (role?: string, reports?: boolean, without?: string) => {
  return useQuery({
    queryKey: ["users", role ?? "all", reports ?? false, without ?? "none"],
    queryFn: () => getUsers(role, reports, without),
    staleTime: 0, // Данните са stale веднага — при всяко mount се прави нов fetch
    refetchOnMount: "always", // Винаги рефреширай при mount на компонента
  });
};
